import { Component, Input } from '@angular/core';
import { Validators } from '@angular/forms';
import { createForm } from '@sonofabit/ng-core';
import { IdReferenceDto } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-scan-section-select-dialog',
  templateUrl: './scan-section-select-dialog.component.html',
})
export class ScanSectionSelectDialogComponent {
  @Input() buildingId!: string;

  readonly form = createForm(({ field }) => ({
    sections: field({
      value: [] as IdReferenceDto[],
      validators: [Validators.required],
    }),
  }));

  onSubmit(): string[] | false {
    this.form.markAsTouched();
    if (!this.form.valid) {
      return false;
    }
    return (this.form.value.sections ?? []).map((section: IdReferenceDto) => section.value!);
  }

  get disableSubmit(): boolean {
    return !this.form.valid;
  }
}
